import type { ReactNode } from 'react';
export type BarRow = {
  key: string;
  label: ReactNode;
  value: number;
  display: string;
  meta?: string;
};
type Props = {
  rows: BarRow[];
  max?: number;
  empty?: string;
  tone?: 'clay' | 'sage' | 'ink';
};
const toneCls = {
  clay: 'bg-clay/70',
  sage: 'bg-sage/70',
  ink: 'bg-ink/70'
} as const;

/** Een gerangschikte lijst met een balkje: leest als tekst, de balk laat de verhouding zien. */
export function BarList({
  rows,
  max,
  empty = 'Niets in deze periode.',
  tone = 'clay'
}: Props) {
  if (rows.length === 0) return <p className="py-4 text-[13px] text-muted" data-id="element-1835" data-mp="12uk1tflitzng">{empty}</p>;
  const top = max ?? Math.max(1, ...rows.map(r => r.value));
  return <ul className="space-y-3" data-id="element-1836" data-mp="y0fugv8cfplu">
      {rows.map(r => <li key={r.key} data-id="element-1837" data-mp="tzvyvw3f4u1t">
          <div className="flex items-baseline justify-between gap-3 text-[13px]" data-id="element-1838" data-mp="u0ovw5cks56r">
            <span className="min-w-0 truncate text-ink" data-id="element-1839" data-mp="1qjms1bu810tk">{r.label}</span>
            <span className="shrink-0 tabular-nums text-ink" data-id="element-1840" data-mp="1lrl8r5ymy9u1">
              {r.display}
              {r.meta && <span className="ml-1.5 text-muted" data-id="element-1841" data-mp="1gxpjyj0zn8rc">{r.meta}</span>}
            </span>
          </div>
          <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-sand" aria-hidden="true" data-id="element-1842" data-mp="1lxvgaci7djfr">
            <div className={`h-full rounded-full ${toneCls[tone]}`} style={{
          width: `${Math.max(1, Math.max(0, r.value) / top * 100)}%`
        }} data-id="element-1843" data-mp="178z9sjvsoeh9" />
          </div>
        </li>)}
    </ul>;
}